import { useContext, useEffect, useState } from 'react';
import { getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
import { convertSecondsToHMS } from '../../../../../../../helpers/Dates';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

const MinSecTimeSelect = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const value = getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);

    const [timeM, setTimeM] = useState(0);
    const [timeS, setTimeS] = useState(0);

    // Hms timefields don't care about timezones - timezone adjustments should be done before submitting to the server and after retrival if needed
    const updateTimeInSecs = (/*h,*/ m, s) => {
        let timeInSecs = parseInt(s || 0) + parseInt((m || 0) * 60) /*+ parseInt((h || 0) * 3600)*/;
        WORKING_ON_NODE_DATA.fieldData = fieldData;
        WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
        updateCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, timeInSecs, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
        props?.forceUpdateComponent?.();
        return timeInSecs;
    }

    const updateTimeM = (val) => {
        val = val >= 0 ? (val <= 59 ? val : 59) : 0;
        updateTimeInSecs(val, timeS);
        setTimeM(val);
    }

    const updateTimeS = (val) => {
        val = val >= 0 ? (val <= 59 ? val : 59) : 0;
        updateTimeInSecs(timeM, val);
        setTimeS(val);
    }

    useEffect(
        () => {
            const setInitialHMS = (timeInSecs) => {
                // No timezone stuff here! But we do want to clamp times that are not relative
                let hmsTime = convertSecondsToHMS(timeInSecs, true);
                // console.log('SET TIME', hmsTime)
                if (hmsTime.m !== timeM) {
                    setTimeM(hmsTime.m);
                }
                if (hmsTime.s !== timeS) {
                    setTimeS(hmsTime.s);
                }
            }

            setInitialHMS(value);
        },
        [value]
    );

    const secondsOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
    const minutesOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Time (Min:Sec)'}</div>
            <div className='fl-row compact grow'>
                <div className='grow'>
                    <ModuleNumericalInput
                        value={timeM}
                        fieldId={'min-time-field'}
                        enabled={props.isEnabled}
                        editable={true}
                        onChange={(fieldId, value) => {updateTimeM(value);}}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={minutesOptions}
                    />
                </div>
                <div className='shrink'>mins</div>
                <div className='grow'>
                    <ModuleNumericalInput
                        value={timeS}
                        fieldId={'sec-time-field'}
                        enabled={props.isEnabled}
                        editable={true}
                        onChange={(fieldId, value) => {updateTimeS(value);}}
                        options={secondsOptions}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={secondsOptions}
                    />
                </div>
                <div className='shrink'>secs</div>
            </div>
        </>
    );
}

export default MinSecTimeSelect;